import './contributor-details.css';
